/**
 * Truncates a display name to a maximum length with ellipsis.
 * @param name - The display name to truncate
 * @param maxLength - Maximum allowed length (default: 50)
 * @returns The name unchanged if within limit, or truncated with '…' appended
 */
export function truncateDisplayName(
  name: string,
  maxLength: number = 50
): string {
  if (name.length <= maxLength) {
    return name
  }
  return name.slice(0, maxLength) + '\u2026'
}
